<template>
  <div class="flex w-full h-full" v-if="teams[$route.params.team].account">
    <v2-delete-modal
      v-if="currentDeleteFilterPreset"
      :name="'delete-filter-preset-modal' + currentDeleteFilterPreset"
      :title="
        $t('modals.deleteFilterPreset.title', {
          name: currentDeleteFilterPreset.title,
        })
      "
      :text="$t('modals.deleteFilterPreset.text')"
      :startHtmlScrollToggle="false"
      :deleteHandler="
        () => {
          removeFilterPreset();
        }
      "
    ></v2-delete-modal>
    <v2-inbox-navigation
      :isLoading="navIsLoading"
      :isMobile="isMobile"
      :getSelf="getProject"
      :setNotificationStatus="setNotificationStatus"
      :timezone="teams[$route.params.team].account.timezone"
      :locale="teams[$route.params.team].account.locale"
      :projectsWithMessages="projectsWithMessages"
      :projects="projects"
      :projectsMessages="projectsMessages"
      :selectedProject="teamsSettings[$route.params.team].currentInboxProject"
      :filterPresets="currentFilterPresets"
      :filters="filters"
      :groups="groups"
      :inboxActive="teamsSettings[$route.params.team].inboxNavi.inboxActive"
      :filterActive="teamsSettings[$route.params.team].inboxNavi.filterActive"
      :addFilterActive="teamsSettings[$route.params.team].inboxNavi.addFilterActive"
      :newMessageActive="teamsSettings[$route.params.team].inboxNavi.newMessageActive"
      :broadcastsActive="teamsSettings[$route.params.team].inboxNavi.broadcastsActive"
      :newBroadcastFilterActive="teamsSettings[$route.params.team].inboxNavi.newBroadcastFilterActive"
      :isEditMode="teamsSettings[$route.params.team].inboxNavi.isEditMode"
      :setCurrentInboxProject="setCurrentInboxProject"
      :currentEditFilterPreset="teamsSettings[$route.params.team].inboxNavi.currentPreset"
      :activeFilterPreset="teamsSettings[$route.params.team].listsSettings.inboxWithMessages.currentFilterPreset"
      :currentInboxBroadcast="currentInboxBroadcast"
      :broadcastsProjectsCount="broadcastsProjectsCount"
      :searchQuery="searchQuery"
      :deleteBroadcast="deleteFilterPreset"
      @search="
        (data) => {
          searchProjects(data.value, false, data.messages);
        }
      "
      :searchProjectsQuery="searchProjectsQuery"
      @searchProjects="
        (value) => {
          searchProjects(value, true);
        }
      "
      @toggleSubscription="
        (data) => {
          toggleSubscription(data);
        }
      "
      @filterProjects="
        (preset) => {
          filterProjects(preset);
        }
      "
      @removeActiveFilterPreset="removeActiveFilterPreset"
      @resetFilters="resetFilters"
      @toggleInboxNavi="
        (data) => {
          toggleNavi(data);
        }
      "
      @selectPreset="
        (preset) => {
          selectFilterPreset(preset);
        }
      "
      @savePreset="
        (data) => {
          savePreset(data);
        }
      "
      @projectSelection="
        (project) => {
          selectProject(project);
        }
      "
      @broadcastSelection="
        (broadcast) => {
          selectBroadcast(broadcast);
        }
      "
      @loadNextProjectsWithMessagesPage="loadNextProjectsWithMessagesPage"
      @loadNextProjectsPage="loadNextProjectsPage"
    ></v2-inbox-navigation>
    <v2-inbox-messages
      :isMobile="isMobile"
      :locale="teams[$route.params.team].account.locale"
      :messagesActive="teamsSettings[$route.params.team].inboxNavi.messagesActive"
      :broadcastMessagesMobileActive="teamsSettings[$route.params.team].inboxNavi.broadcastMessagesMobileActive"
      :viewportHeight="viewportHeight"
      :timezone="teams[$route.params.team].account.timezone"
      :project="teamsSettings[$route.params.team].currentInboxProject"
      :projectStats="currentInboxProjectStats"
      :currentUser="teams[$route.params.team].account"
      :currentBroadcast="currentInboxBroadcast"
      :currentProjectWhatsappMeta="currentProjectsMessagesWhatsappMeta"
      :getSelf="getProject"
      :getProjectMessages="getProjectMessages"
      :getBroadcastMessages="getFilterPresetMessages"
      :setCurrentInboxProject="setCurrentInboxProject"
      :currentProjectMessages="currentProjectMessages"
      :currentProjectMessagesPagination="currentProjectMessagesPagination"
      :showProjectData="showProjectData"
      :projectsStati="projectsStati"
      :whatsAppNumbers="teams[$route.params.team].account.team.attributes.whatsapp_senders"
      :broadcastsActive="
        teamsSettings[$route.params.team].inboxNavi.broadcastsActive ||
        teamsSettings[$route.params.team].inboxNavi.newBroadcastFilterActive
      "
      :sendProjectMessage="sendProjectMessage"
      :sendBroadcastMessages="sendFilterPresetMessages"
      @updateProjects="getProjectsWithMessages(false, false)"
      @openPreview="
        (project) => {
          openPreview(project);
        }
      "
      @toggleSubscription="
        (data) => {
          toggleSubscription(data);
        }
      "
      @toggleInboxNavi="
        (data) => {
          toggleNavi(data);
        }
      "
      @toggleShowProjectData="toggleShowInboxProjectData(!showProjectData)"
    ></v2-inbox-messages>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import filterPresets from "@/mixins/filterPresets_v2.js";
import inbox from "@/mixins/filters/inbox.js";
import listSettings from "@/mixins/listSettings_v2.js";

export default {
  name: "Inbox",
  mixins: [listSettings, inbox, filterPresets],
  data() {
    return {
      isMobile: false,
      navIsLoading: false,
      projects: null,
      projectsMessages: null,
      projectsWithMessages: null,
      viewportHeight: 200,
      searchQuery: "",
      searchProjectsQuery: "",
      currentDeleteFilterPreset: null,
      dateTimeFormat: {
        stringify: (date) => {
          return date
            ? this.$moment(date).tz(this.teams[this.$route.params.team].account.timezone).format("L HH:mm")
            : null;
        },
        parse: (value) => {
          return value
            ? this.$moment(value, "L HH:mm").tz(this.teams[this.$route.params.team].account.timezone).toDate()
            : null;
        },
      },
    };
  },
  created() {
    // check if mobile view
    this.checkView(false, true);
    // set viewportHeight
    this.viewportHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // set html to overflow hidden
    document.documentElement.className = "";
    document.body.className = "hide";
    // set Datetime format for filters
    this.setDateTimeFormat();
    // init Inbox Data
    if (this.redirectedProject) {
      // toggle inbox navi to inbox
      this.toggleInboxNavi({ str: "inbox" });
      // check if project object or uid only, if uid, get project and set object
      if (!this.redirectedProject.uid) {
        this.getProject({ project: this.redirectedProject }).then((res) => {
          this.setRedirectedInboxProject(res.data.data);
          // set searchQuery if redirected from Project
          this.searchQuery = this.redirectedProject.title;
          this.searchProjectsQuery = this.redirectedProject.title;
          this.afterRedirectHandling();
        });
      } else {
        // set searchQuery if redirected from Project
        this.searchQuery = this.redirectedProject.title;
        this.searchProjectsQuery = this.redirectedProject.title;
        this.afterRedirectHandling();
      }
    } else {
      // set searchQuery from store
      if (this.teamsSettings[this.$route.params.team]) {
        if (this.teamsSettings[this.$route.params.team].listsSettings.inboxWithMessages.search) {
          this.searchQuery = this.teamsSettings[this.$route.params.team].listsSettings.inboxWithMessages.search;
        }
        if (this.teamsSettings[this.$route.params.team].listsSettings.inbox.search) {
          this.searchProjectsQuery = this.teamsSettings[this.$route.params.team].listsSettings.inbox.search;
        }
      }
      this.afterRedirectHandling();
    }
    // add resize event for mobile view check
    window.addEventListener("resize", this.checkView);
    this.$eventbus.$on("reloadProjectsWithMessages", this.reloadProjectsWithMessages);
  },
  beforeDestroy() {
    // remove overflow hidden from body
    document.body.className = "";
    // destroy resize event for mobile view check
    window.removeEventListener("resize", this.checkView);
  },
  methods: {
    ...mapActions([
      "getProjectList",
      "getProject",
      "getTeamTemplates",
      "getTeamContacts",
      "getUsers",
      "getTeamTags",
      "setProjectsCustomFields",
      "addCustomFilterToListsettings",
      "toggleInboxNavi",
      "setCurrentFilterPreset",
      "postProjectSubscription",
      "deleteProjectSubscription",
      "setCurrentInboxProject",
      "setCurrentInboxProjectStats",
      "setCurrentInboxBroadcast",
      "toggleShowInboxProjectData",
      "getProjectMessages",
      "getProjectsMessages",
      "getProjectBuilderSession",
      "sendProjectMessage",
      "sendFilterPresetMessages",
      "getProjectStats",
      "setNotificationStatus",
      "setRedirectedInboxProject",
      "getFilterPresetMessages",
      "deleteFilterPreset",
    ]),
    afterRedirectHandling() {
      if (this.inboxNavi && this.inboxNavi.filterActive) {
        this.loadFilterPresets("inbox");
      }
      if (this.inboxNavi && this.inboxNavi.broadcastsActive) {
        this.loadFilterPresets("broadcast");
      }
      if (this.inboxNavi && this.inboxNavi.newMessageActive) this.getProjects();
      this.getProjectsWithMessages(true);
    },
    setDateTimeFormat() {
      if (this.teams[this.$route.params.team].account) {
        for (let i = 0; i < this.filters.length; i += 1) {
          if (this.filters[i].dateTimeRange) {
            this.filters[i].dateTimeRange.dateTimeFormat = this.dateTimeFormat;
            this.filters[i].dateTimeRange.lang = this.teams[this.$route.params.team].account.locale;
          }
        }
      }
    },
    reloadProjectsWithMessages(projectUid) {
      this.getProjectsWithMessages(false);
      // only reloadMessages if current selected project is the same as the one that was updated
      if (this.currentInboxProject && this.currentInboxProject.uid === projectUid) {
        this.$eventbus.$emit("reloadMessages", projectUid);
      }
    },
    getProjectsWithMessages(init = false, loading = true) {
      if (this.inboxNavi && this.inboxNavi.inboxActive && loading) {
        this.navIsLoading = true;
      }
      const vm = this;
      let params = {};
      if (this.teamsSettings[this.$route.params.team].listsSettings.inboxWithMessages.currentFilterPreset) {
        params = this.setFilterPresetToRequestParams(
          this.teamsSettings[this.$route.params.team].listsSettings.inboxWithMessages.currentFilterPreset
        );
      }
      params.has_any_messages = true;
      params.include_unread_message_count = true;
      params.include_latest_message_date = true;
      params.include_subscribed = true;
      params.search = this.searchQuery;
      params.order_col = "last_message";
      params.order_dir = "DESC";
      vm.getProjectList({
        customLoading: true,
        setListsSettings: true,
        list: "inboxWithMessages",
        params,
      })
        .then((res) => {
          this.projectsWithMessages = res.data.data;
          if (this.inboxNavi.inboxActive) {
            this.navIsLoading = false;
          }
          if (init) {
            vm.preselectProject();
            vm.loadFilterPresets("inbox");
            vm.loadFilterPresets("broadcast");
            vm.setCustomFields(res.data.meta.custom);
            vm.loadFilterData();
          }
        })
        .catch(() => {
          if (this.inboxNavi && this.inboxNavi.inboxActive) this.navIsLoading = false;
        });
    },
    loadNextProjectsWithMessagesPage() {
      const vm = this;
      if (
        vm.teamsSettings[vm.$route.params.team].listsSettings.inboxWithMessages.pagination.page <
        vm.teamsSettings[vm.$route.params.team].listsSettings.inboxWithMessages.pagination.lastPage
      ) {
        let params = {};
        if (vm.teamsSettings[vm.$route.params.team].listsSettings.inboxWithMessages.currentFilterPreset) {
          params = vm.setFilterPresetToRequestParams(
            vm.teamsSettings[vm.$route.params.team].listsSettings.inboxWithMessages.currentFilterPreset
          );
        }
        params.has_any_messages = true;
        params.include_unread_message_count = true;
        params.include_latest_message_date = true;
        params.include_subscribed = true;
        params.search = vm.searchQuery;
        params.order_col = "last_message";
        params.order_dir = "DESC";
        params.page = vm.teamsSettings[vm.$route.params.team].listsSettings.inboxWithMessages.pagination.page + 1;
        vm.getProjectList({
          customLoading: true,
          setListsSettings: true,
          list: "inboxWithMessages",
          params,
        }).then((res) => {
          vm.projectsWithMessages = [...vm.projectsWithMessages, ...res.data.data];
        });
      }
    },
    getProjects() {
      if (this.inboxNavi && this.inboxNavi.newMessageActive) {
        this.navIsLoading = true;
      }
      const params = {
        search: this.searchProjectsQuery,
        order_col: "title",
        order_dir: "ASC",
        include_latest_message_date: true,
        include_subscribed: true,
      };
      this.getProjectList({
        customLoading: true,
        setListsSettings: true,
        list: "inbox",
        params,
      })
        .then((res) => {
          this.projects = res.data.data;
          if (this.redirectedProject) {
            this.projects.forEach((project) => {
              if (project.uid === this.redirectedProject.uid) {
                this.selectProject(project);
                this.setRedirectedInboxProject(null);
              }
            });
          }
          if (this.inboxNavi && this.inboxNavi.newMessageActive) {
            this.navIsLoading = false;
          }
        })
        .catch(() => {
          if (this.inboxNavi && this.inboxNavi.newMessageActive) {
            this.navIsLoading = false;
          }
        });
    },
    loadNextProjectsPage() {
      if (
        this.teamsSettings[this.$route.params.team].listsSettings.inbox.pagination.page <
        this.teamsSettings[this.$route.params.team].listsSettings.inbox.pagination.lastPage
      ) {
        const params = {
          search: this.teamsSettings[this.$route.params.team].listsSettings.inbox.search,
          order_col: "title",
          order_dir: "ASC",
          page: this.teamsSettings[this.$route.params.team].listsSettings.inbox.pagination.page + 1,
        };
        this.getProjectList({
          customLoading: true,
          setListsSettings: true,
          list: "inbox",
          params,
        }).then((res) => {
          this.projects = [...this.projects, ...res.data.data];
        });
      }
    },
    loadFilterData() {
      const vm = this;
      const p1 = vm.getTeamTemplates({
        params: { per_page: "1000" },
        customLoading: true,
      });
      const params = {
        per_page: "1000",
        order_col: "last_name",
        order_dir: "ASC",
        search: "",
      };
      const p2 = vm.getTeamContacts({ params, customLoading: true });
      const p3 = vm.getUsers({ params, customLoading: true });
      const p4 = vm.getTeamTags({ params, customLoading: true });
      Promise.all([p1, p2, p3, p4]).then(() => {
        this.setFilterOptions();
      });
    },
    setCustomFields(customFields) {
      const vm = this;
      this.setProjectsCustomFields(customFields).then(() => {
        vm.setCustomFilters("inboxWithMessages");
        if (vm.inboxNavi.isEditMode && vm.inboxNavi.currentPreset) {
          vm.selectFilterPreset(vm.inboxNavi.currentPreset);
        }
      });
    },
    searchProjectsMessages() {
      this.navIsLoading = true;
      const params = {
        search: this.searchQuery,
        order_col: "created_at",
        order_dir: "DESC",
      };
      this.getProjectsMessages({
        customLoading: true,
        params,
      })
        .then((res) => {
          this.projectsMessages = res.data.data;
          this.navIsLoading = false;
        })
        .catch(() => {
          this.navIsLoading = false;
        });
    },
    searchProjects(value, searchProjects = false, messages = false) {
      if (searchProjects) {
        this.searchProjectsQuery = value;
        const params = {
          search: this.searchProjectsQuery,
          order_col: "title",
          order_dir: "ASC",
          include_latest_message_date: true,
          include_subscribed: true,
        };
        this.getProjectList({
          customLoading: true,
          setListsSettings: true,
          list: "inbox",
          params,
        }).then((res) => {
          this.projects = res.data.data;
        });
      } else {
        this.searchQuery = value;
        !messages ? this.getProjectsWithMessages(false) : this.searchProjectsMessages();
      }
    },
    preselectProject() {
      if (this.redirectedProject) {
        let messagesFound = false;
        this.projectsWithMessages.forEach((project) => {
          if (project.uid === this.redirectedProject.uid) {
            messagesFound = true;
            this.toggleInboxNavi({ str: "inbox" });
            this.selectProject(project);
            this.navIsLoading = false;
            this.setRedirectedInboxProject(null);
          }
        });
        if (!messagesFound) {
          this.toggleInboxNavi({ str: "newMessageActive" });
          this.getProjects();
          this.searchQuery = "";
          this.getProjectsWithMessages(false, false);
        }
        const url = this.$h.removeURLParameter(window.location.href, "uid");
        window.history.replaceState("", "", url);
      }
    },
    selectProject(project) {
      this.setCurrentInboxProject(project);
      this.getProjectStats({ project: project.uid, customLoading: true }).then((res) => {
        this.setCurrentInboxProjectStats(res.data.data);
        this.isMobile ? this.toggleNavi({ str: "messagesMobile" }) : this.toggleNavi({ str: "messages" });
      });
    },
    selectBroadcast(broadcast) {
      this.setCurrentInboxBroadcast(broadcast);
      this.isMobile ? this.toggleNavi({ str: "broadcastMessagesMobile" }) : this.toggleNavi({ str: "messages" });
    },
    removeFilterPreset() {
      this.deletePreset(this.currentDeleteFilterPreset, "inbox", () => {
        this.toggleInboxNavi({ str: "filter" });
        this.$modal.hide("delete-filter-preset-modal" + this.currentDeleteFilterPreset);
      });
    },
    setFilterPresetToRequestParams(preset) {
      let params = {
        has_any_messages: true,
        include_unread_message_count: true,
        include_latest_message_date: true,
        include_subscribed: true,
      };
      Object.assign(params, preset.value);
      if (params.time_relative && params.time_from && params.time_to) {
        params.time_from = "";
        params.time_to = "";
      }
      if (params.time_from && params.time_to && !params.time_relative) {
        params.time_relative = "custom";
      }
      params.search = this.searchQuery;
      return params;
    },
    filterProjects(preset) {
      let vm = this;
      this.navIsLoading = true;
      this.toggleInboxNavi({ str: "inbox" });
      let params = this.setFilterPresetToRequestParams(preset);
      vm.getProjectList({
        customLoading: true,
        setListsSettings: true,
        list: "inboxWithMessages",
        params,
      })
        .then((res) => {
          this.projectsWithMessages = res.data.data;
          vm.setCurrentFilterPreset({
            list: "inboxWithMessages",
            filterPreset: preset,
          });
          this.navIsLoading = false;
        })
        .catch(() => {
          this.navIsLoading = false;
        });
    },
    removeActiveFilterPreset() {
      this.setCurrentFilterPreset({
        list: "inboxWithMessages",
        filterPreset: null,
      });
      this.getProjectsWithMessages(false);
    },
    toggleNavi(data) {
      const vm = this;
      if (data.str === "inbox" || data.str === "broadcasts") {
        this.$eventbus.$emit("messagesIsLoading");
      }
      vm.toggleInboxNavi(data);
      vm.$nextTick(() => {
        const broadcastsCb = (res) => {
          vm.navIsLoading = false;
          vm.currentInboxBroadcast !== null
            ? vm.$eventbus.$emit("reloadMessages", vm.currentInboxBroadcast.uid)
            : res.data.data.length > 0
            ? vm.selectBroadcast(res.data.data[0])
            : vm.$eventbus.$emit("resetMessages");
        };
        switch (data.str) {
          case "filter":
            vm.navIsLoading = true;
            vm.loadFilterPresets("inbox", (vm.navIsLoading = false), (vm.navIsLoading = false));
            break;
          case "inbox":
            if (vm.currentInboxProject !== null) {
              vm.$eventbus.$emit("reloadMessages", vm.currentInboxProject.uid);
            } else {
              vm.$eventbus.$emit("resetMessages");
            }
            break;
          case "broadcasts":
            vm.navIsLoading = true;
            vm.loadFilterPresets("broadcast", broadcastsCb, (vm.navIsLoading = false));
            break;
          case "newMessageActive":
            vm.getProjects();
            break;
        }
      });
    },
    toggleSubscription(data) {
      const vm = this;
      if (data.project.subscribed) {
        vm.deleteProjectSubscription({
          customLoading: true,
          project: data.project.uid,
        })
          .then(() => {
            if (data.cb) {
              data.cb();
            }
            vm.$snotify.success(vm.$t("toasts.deleteSubscription.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch((err) => {
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("toasts.deleteSubscription.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
          });
      } else {
        vm.postProjectSubscription({
          customLoading: true,
          project: data.project.uid,
        })
          .then(() => {
            if (data.cb) {
              data.cb();
            }
            vm.$snotify.success(vm.$t("toasts.setSubscription.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch((err) => {
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("toasts.setSubscription.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
          });
      }
    },
    openPreview(project) {
      const vm = this;
      vm.getProjectBuilderSession({
        params: {
          project: project,
        },
        data: {
          return_url: window.location.href,
          preview: true,
        },
      })
        .then(() => {
          location.href = vm.builderSession;
        })
        .catch(() => {});
    },
    savePreset(data) {
      const vm = this;
      if (this.inboxNavi && this.inboxNavi.addFilterActive) {
        vm.navIsLoading = true;
      }
      const type = vm.teamsSettings[vm.$route.params.team].inboxNavi.newBroadcastFilterActive ? "broadcast" : "inbox";
      vm.saveFilterPreset(
        data.thisFilters,
        type,
        data.filterName,
        data.isEditMode,
        (res) => {
          if (this.inboxNavi && this.inboxNavi.addFilterActive) {
            vm.navIsLoading = false;
          }
          if (vm.teamsSettings[vm.$route.params.team].inboxNavi.addFilterActive) {
            vm.toggleInboxNavi({ str: "filter" });
          } else if (vm.teamsSettings[vm.$route.params.team].inboxNavi.newBroadcastFilterActive) {
            vm.selectBroadcast(res);
            vm.toggleInboxNavi({ str: "broadcasts" });
          }
        },
        (err) => {
          if (this.inboxNavi && this.inboxNavi.addFilterActive) {
            vm.navIsLoading = false;
          }
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.createFilterPreset.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        }
      );
    },
    checkView(e, init = false) {
      const mediaQuery = window.matchMedia("(max-width: 850px)");
      this.isMobile = mediaQuery.matches;
      if (!init && !this.isMobile) {
        this.toggleNavi({ str: "inbox" });
      }
    },
  },
  computed: {
    ...mapGetters({
      teamsSettings: "global_get_teams_settings",
      teams: "auth_get_teams",
      inboxFilterPresets: "filterpresets_get_filterpresets_inbox",
      broadcastFilterPresets: "filterpresets_get_filterpresets_broadcast",
      projectsStati: "projects_get_projects_stati",
      projectsCustomFields: "global_get_projects_custom_fields",
      templates: "templates_get_templates",
      users: "user_get_users",
      contacts: "teams_get_contacts",
      teamTags: "teams_get_tags",
      inboxNavi: "global_get_inbox_navi",
      currentInboxProject: "global_get_current_inbox_project",
      currentInboxProjectStats: "global_get_current_inbox_project_stats",
      currentInboxBroadcast: "global_get_current_inbox_broadcast",
      showProjectData: "global_get_show_inbox_project_data",
      builderSession: "projects_get_builder_session",
      redirectedProject: "global_get_redirected_inbox_project",
      broadcastsProjectsCount: "filterpresets_get_broadcasts_projects_count",
      currentProjectMessages: "projects_get_current_project_messages",
      currentProjectMessagesPagination: "projects_get_messages_pagination",
      currentProjectsMessagesWhatsappMeta: "projects_get_current_projects_messages_whatsapp_meta",
    }),
    currentFilterPresets() {
      return this.teamsSettings[this.$route.params.team].inboxNavi.broadcastsActive
        ? this.broadcastFilterPresets
        : this.inboxFilterPresets;
    },
  },
};
</script>
